export default {
  // 导航栏
  nav: {
    welcome: 'Welcome',
    company: 'Company',
    products: 'Products',
    links: 'Contact',
    language: 'English'
  },
  
  // 首页
  home: {
    title: 'AI-Powered Microbial Detection',
    subtitle1: 'Food Safety',
    subtitle2: 'Public Health',
    logoAlt: 'Pasteur Biotech'
  },
  
  // 公司页面
  company: {
    title: 'Corporate Culture',
    mission: 'Mission',
    missionText: 'AI-powered microbial detection for food safety and public health',
    vision: 'Vision',
    visionText: 'Global leader in microbial detection solutions',
    values: 'Values',
    value1: 'Innovation',
    value1Text: 'Continuous innovation in technology',
    value2: 'Quality',
    value2Text: 'Excellence in quality and precision',
    value3: 'Service',
    value3Text: 'Professional service and client focus',
    // 核心优势
    coreAdvantages: 'Core Advantages',
    advantages: {
      automation: 'Fully Automated Microbial Detection Equipment',
      aiModel: 'Microbial Vertical AI Model',
      pipeline: 'Pathogenic Microbial Detection Pipeline'
    },
    // 关于我们
    about: {
      subtitle: 'ABOUT US',
      title: 'Company Profile',
      description: [
        'Pasteur (PASTEUR) is a high-tech enterprise specializing in AI-powered microbial detection. We are committed to providing precise and efficient microbial detection solutions for the healthcare industry through cutting-edge AI technology.',
        'Our company brings together outstanding talent from top domestic and international universities and research institutions, with deep technical expertise in artificial intelligence, microbiology, and medical imaging. Our R&D team consists of multiple PhDs and senior engineers, continuously driving technological innovation and product upgrades.'
      ],
      mission: 'AI-powered microbial detection for food safety and public health'
    },
    // 品牌故事
    brandStory: {
      subtitle: 'BRAND STORY',
      title: 'Brand Story',
      mainTitle: 'Tribute to Pasteur—Founder of Microbiology, Immunology, and Public Health Epidemiology!',
      description: [
        'Louis Pasteur (December 27, 1822 - September 28, 1895), also known as Louis Pasteur, was born in Dole, eastern France. He graduated from the University of Paris with a doctorate and is founder of immunology and health epidemiology, as well as a French chemist and microbiologist.',
        'In his later years, Pasteur returned to his alma mater for a speech, mentioning two factors that enabled him to succeed despite facing great opposition: "Faith, believing in divine revelation, faith is a rope that connects what happens around you with your inner calling, forming a harmonious relationship." This shows Pasteur accepted divine calling with faith—fighting for the Lord and the Bible on the scientific battlefield. The second factor for success: "Enthusiasm, the best word, composed of En and Theo; En means within, Theo means God. True lasting enthusiasm comes from God living in my heart."'
      ],
      honors: [
        'Founder of Microbiology',
        'Inventor of Pasteurization',
        'Pioneer of Vaccines',
        'Discoverer of Chiral Chemistry',
        'Revolutionary in Public Health',
        'Model of Scientific Research and Practice Integration'
      ],
      pasteurAlt: 'Portrait of Louis Pasteur',
      confidenceAlt: 'Faith and Enthusiasm'
    },
    // 客户成就
    customerAchievement: 'Customer Achievement'
  },
  
  // 产品页面
  products: {
    positioning: 'Market Positioning',
    foreignStatus: 'Global Status',
    domesticStatus: 'Domestic Status',
    viewDetails: 'View Details',
    overview: {
      subtitle: 'Product Overview',
      title: 'Product Overview',
      description: [
        'Pasteur Medical Equipment Co., Ltd. specializes in R&D and application of intelligent microbiology laboratory solutions. Our patented LIMS microbiology laboratory management system provides comprehensive intelligent management for food, pharmaceutical, and membrane filter sample testing.',
        'The company offers a complete product line for microbiology testing, including sample processing equipment, microbial incubation equipment, microbial counting equipment, and rapid detection equipment. All products feature patented technologies, enabling fully automated detection workflows from sample receipt to result output.'
      ],
      features: [
        { icon: '🏢', text: 'Patented LIMS technology with strong device compatibility' },
        { icon: '🧪', text: 'Patented pour plate method for standardized sample processing' },
        { icon: '🌡️', text: 'Patented temperature and humidity control for precise incubation' },
        { icon: '📈', text: 'Patented microbial identification for intelligent counting and classification' }
      ],
      stats: [
        { number: '10+', label: 'Core Patents' },
        { number: '4', label: 'Product Series' },
        { number: '90%', label: 'Automation Coverage' },
        { number: 'GMP', label: 'Compliance Standards' }
      ]
    },
    flagship: {
      subtitle: 'Core Products',
      title: 'Core Products',
      items: [
        {
          category: 'LIMS Management',
          name: 'LIMS Microbiology Laboratory Management System',
          description: 'Patented laboratory information management system enabling device compatibility and full workflow automation. Supports standardized testing processes for food, pharmaceutical, and membrane filter samples.',
          icon: '🖥️',
          specs: [
            { label: 'Patented Tech', value: 'LIMS System Architecture' },
            { label: 'Device Support', value: 'Full Equipment Range' },
            { label: 'Sample Types', value: 'Food/Pharma/Membranes' }
          ],
          tags: ['Patented LIMS', 'Device Compatible', 'Full Workflow Management']
        },
        {
          category: 'Sample Processing',
          name: 'Intelligent Sample Processing System',
          description: 'Sample preprocessing equipment featuring patented pour plate technology with precision temperature and humidity control systems, ensuring standardized and consistent sample processing.',
          icon: '🧫',
          specs: [
            { label: 'Patented Tech', value: 'Pour Plate Method' },
            { label: 'Temp Precision', value: '±0.1°C' },
            { label: 'Humidity Control', value: '±2% RH' }
          ],
          tags: ['Pour Plate Patent', 'Temp/Humidity Control', 'Standardized Processing']
        },
        {
          category: 'Incubation Equipment',
          name: 'Microbial Incubation System',
          description: 'Integrated microbial incubation, anaerobic incubation, and temperature/humidity control patented technologies, providing optimal growth environments for improved incubation efficiency and success rates.',
          icon: '🦠',
          specs: [
            { label: 'Patented Tech', value: 'Microbial/Anaerobic Incubation' },
            { label: 'Temp Range', value: '4-60°C' },
            { label: 'Incubation Capacity', value: '100-500 samples' }
          ],
          tags: ['Microbial Incubation Patent', 'Anaerobic Culture', 'Precision Temp Control']
        },
        {
          category: 'Counting Equipment',
          name: 'Intelligent Microbial Counting System',
          description: 'Intelligent equipment based on microbial counting, identification, and classification patented technologies, enabling automated colony recognition, counting, and classification for significantly improved detection efficiency.',
          icon: '🔍',
          specs: [
            { label: 'Patented Tech', value: 'Counting/Identification/Classification' },
            { label: 'Recognition Accuracy', value: '≥99.5%' },
            { label: 'Counting Speed', value: '<30 sec/plate' }
          ],
          tags: ['Microbial Counting Patent', 'Intelligent Recognition', 'Auto Classification']
        },
        {
          category: 'Rapid Detection',
          name: 'Rapid Microbial Detection System',
          description: 'Integrated rapid microbial detection, colony recovery rate, and GMP-related patented technologies, enabling rapid detection while ensuring quality control compliance with GMP standards.',
          icon: '⏱️',
          specs: [
            { label: 'Patented Tech', value: 'Rapid Detection/Recovery Rate/GMP' },
            { label: 'Detection Time', value: '2-8 hours' },
            { label: 'GMP Compliance', value: '100% Compliant' }
          ],
          tags: ['Rapid Detection Patent', 'Colony Recovery Rate', 'GMP Standards']
        }
      ]
    },
    advantages: {
      subtitle: 'Technical Advantages',
      title: 'Technical Advantages',
      items: [
        {
          title: 'LIMS System Patent',
          description: 'Self-developed LIMS microbiology laboratory management system patent technology, enabling seamless device compatibility and data interoperability, building a complete intelligent detection ecosystem.',
          icon: '🔗',
          metrics: [
            { value: '10+', unit: 'patents', label: 'LIMS Patents' },
            { value: '100', unit: '%', label: 'Device Compatibility' }
          ]
        },
        {
          title: 'Pour Plate Patent Technology',
          description: 'Unique pour plate sample processing patent technology combined with temperature and humidity control systems, ensuring standardized and reproducible sample processing.',
          icon: '🌡️',
          metrics: [
            { value: '±0.1', unit: '°C', label: 'Temp Control Precision' },
            { value: '±2', unit: '%RH', label: 'Humidity Precision' }
          ]
        },
        {
          title: 'Microbial Incubation Patent',
          description: 'Integrated microbial incubation and anaerobic incubation patent technologies, providing optimal growth environments for significantly improved microbial detection accuracy and efficiency.',
          icon: '🥚',
          metrics: [
            { value: '99.5', unit: '%', label: 'Incubation Success Rate' },
            { value: '24-72', unit: 'hours', label: 'Incubation Cycle' }
          ]
        },
        {
          title: 'Intelligent Recognition Patent',
          description: 'Based on microbial counting, identification, and classification patent technologies, enabling automated colony detection for significantly improved detection efficiency and accuracy.',
          icon: '🎯',
          metrics: [
            { value: '99.5', unit: '%', label: 'Recognition Accuracy' },
            { value: '<30', unit: 'sec', label: 'Detection Speed' }
          ]
        },
        {
          title: 'Rapid Detection Patent',
          description: 'Rapid microbial detection, colony recovery rate, and GMP-related patent technologies, enabling rapid detection while ensuring GMP standard compliance.',
          icon: '⚡',
          metrics: [
            { value: '2-8', unit: 'hours', label: 'Rapid Detection Time' },
            { value: '100', unit: '%', label: 'GMP Compliance' }
          ]
        }
      ]
    },
    scenarios: {
      subtitle: 'Application Scenarios',
      title: 'Application Scenarios',
      items: [
        {
          title: 'Food Testing',
          brief: 'Food Microbial Safety Testing',
          description: 'Professional microbial detection solutions for food enterprises, implementing full workflow management from sample receipt to result output through LIMS systems, ensuring food safety.',
          icon: '🍎',
          image: require("@/assets/image/background.png"),
          features: [
            'Food Sample LIMS Management',
            'Standardized Pour Plate Processing',
            'Intelligent Microbial Counting',
            'GMP-Compliant Rapid Detection'
          ]
        },
        {
          title: 'Pharmaceutical Testing',
          brief: 'Pharmaceutical Microbial Limit Testing',
          description: 'GMP-compliant microbial detection services for pharmaceutical enterprises, utilizing patented technologies to ensure microbial quality control in pharmaceutical production processes.',
          icon: '💊',
          image: require("@/assets/image/background.png"),
          features: [
            'Pharmaceutical Sample Tracking',
            'Automated Sterility Testing',
            'Microbial Limit Detection',
            'GMP Standard Compliance'
          ]
        },
        {
          title: 'Membrane Filter Testing',
          brief: 'Membrane Microbial Retention Efficiency Testing',
          description: 'Professional microbial detection services for membrane filter manufacturers, evaluating microbial retention performance through patented pour plate and rapid detection technologies.',
          icon: '🔬',
          image: require("@/assets/image/background.png"),
          features: [
            'Membrane Sample Standardization',
            'Retention Efficiency Testing',
            'Colony Recovery Rate Testing',
            'Data Analysis Reports'
          ]
        },
        {
          title: 'Laboratory Management',
          brief: 'Comprehensive Microbiology Laboratory Solutions',
          description: 'LIMS systems and supporting equipment for various microbiology laboratories, enabling digital transformation and improved detection efficiency and management levels.',
          icon: '🏢',
          image: require("@/assets/image/background.png"),
          features: [
            'LIMS System Deployment',
            'Equipment Integration Compatibility',
            'Standardized Process Management',
            'Data Asset Management'
          ]
        }
      ]
    },
    detectionStages: {
      stages: [
        {
          upperText: 'Traditional Manual',
          lowerText: 'Manual Testing'
        },
        {
          upperText: 'Semi-Automated',
          lowerText: 'Machine Testing'
        },
        {
          upperText: 'Fully Automated',
          lowerText: 'Full Process Monitoring'
        },
        {
          upperText: 'AI-Enhanced Detection',
          lowerText: 'Data Asset Management'
        }
      ]
    }
  },
  
  // 链接页面
  links: {
    emailHint: 'Feel free to contact us if you have any questions',
    heroImageAlt: 'Pasteur Biotech',
    contact: {
      subtitle: 'Contact Us',
      title: 'Contact Us',
      description: 'We look forward to collaborating with you to advance biotechnology innovation',
      items: {
        address: {
          title: 'Company Address',
          content: 'Room 202, Building H, Shanglang Zhichuang Park, No. 61 Pingji Avenue, Shanglang Community, Nanwan Street, Longgang District, Shenzhen'
        },
        phone: {
          title: 'Contact Phone',
          content: '400 686 3798'
        },
        email: {
          title: 'Email Address',
          content: 'contact@bioailego.com'
        },
        hours: {
          title: 'Business Hours',
          content: 'Monday to Friday 9:00-18:30'
        }
      }
    },
    quickContact: {
      title: 'Quick Contact',
      description: 'Leave your information and we will contact you soon'
    },
    form: {
      name: 'Your Name',
      phone: 'Phone Number',
      email: 'Email Address',
      message: 'Please describe your requirements or questions',
      submit: 'Send Message',
      successMessage: 'Thank you for your message. We will reply to you soon!'
    }
  },
  
  // Terms of Service Page
  terms: {
    title: 'Terms of Service',
    subtitle: 'Shenzhen Pasteur Medical Equipment Co., Ltd. Service Terms and Conditions',
    intro: {
      title: 'Agreement Description',
      content: 'Welcome to use products and services from Shenzhen Pasteur Medical Equipment Co., Ltd. This Terms of Service is an agreement between you and Pasteur. Please read all terms carefully, especially liability limitations.'
    },
    sections: {
      service: {
        title: 'Service Description',
        content1: 'Pasteur provides professional microbial detection equipment and solutions:',
        items: [
          'LIMS Laboratory Management System',
          'Intelligent Sample Processing System',
          'Microbial Incubation System',
          'Rapid Microbial Detection System'
        ],
        content2: 'We are committed to providing safe, reliable and efficient detection services in accordance with laws and industry standards.'
      },
      obligations: {
        title: 'User Obligations',
        content: 'When using our products and services, you shall:',
        items: [
          'Comply with laws and regulations, use products for legal purposes only',
          'Operate equipment according to manuals with qualified personnel',
          'Maintain equipment properly and prevent unauthorized use',
          'Report issues promptly and cooperate with maintenance'
        ]
      },
      property: {
        title: 'Intellectual Property',
        content1: 'Pasteur owns complete intellectual property rights to all products, software, documents and trademarks. Unauthorized copying, modification or commercial use is prohibited.',
        content2: 'Our intellectual property includes:',
        items: [
          { text: 'Patented Technologies: LIMS systems, pour plate method, microbial incubation' },
          { text: 'Software Copyrights: Management and control system software' },
          { text: 'Trademark Rights: PASTEUR brand and related trademarks' }
        ]
      },
      privacy: {
        title: 'Privacy Protection',
        content: 'We protect your privacy in accordance with laws and privacy policies. Your personal information will not be sold or transferred to third parties without your consent or legal requirements.',
        notice: {
          title: 'Privacy Protection Commitment',
          content: 'We use encryption technology and strict access controls to ensure your information security.'
        }
      },
      disclaimer: {
        title: 'Disclaimer',
        content: 'To the maximum extent permitted by law, Pasteur shall not be liable for:',
        items: [
          'Damage or errors caused by improper operation or violation of specifications',
          'Service interruption caused by force majeure (natural disasters, wars, etc.)',
          'Issues from third-party software, hardware or network problems'
        ]
      },
      changes: {
        title: 'Agreement Changes',
        content: 'We reserve the right to modify this agreement. Modified agreements will be published on our website and take effect immediately. Continued use constitutes acceptance of changes.'
      },
      dispute: {
        title: 'Dispute Resolution',
        content: 'Disputes shall be resolved through friendly consultation first. If consultation fails, either party may file a lawsuit with the court at Pasteur\'s location. This agreement is governed by the laws of the People\'s Republic of China.'
      },
    },
  },
  
  // Privacy Policy Page
  privacy: {
    title: 'Privacy Policy',
    subtitle: 'Shenzhen Pasteur Medical Equipment Co., Ltd. Privacy Protection Terms',
    intro: {
      title: 'Policy Description',
      content: 'Shenzhen Pasteur Medical Equipment Co., Ltd. (hereinafter referred to as "Pasteur" or "we") deeply understands the importance of your personal information and will do our utmost to protect the security and reliability of your personal information. We are committed to maintaining your trust in us and adhering to the following principles to protect your personal information.'
    },
    sections: {
      collection: {
        title: 'Information Collection',
        content: 'We may collect the following types of information to provide you with better products and services:',
        items: [
          {
            title: 'Personal Basic Information',
            description: 'Including but not limited to name, contact phone number, email address, company name, position, etc., for identification and business contact.'
          },
          {
            title: 'Device Information',
            description: 'Including device model, serial number, usage records, maintenance records, etc., for product support and after-sales service.'
          },
          {
            title: 'Technical Support Information',
            description: 'Including technical consultation records, fault reports, maintenance requests, etc., for providing technical support and product improvement.'
          },
          {
            title: 'Business Communication Information',
            description: 'Including business negotiation records, cooperation intentions, requirement surveys, etc., for business cooperation and product customization.'
          }
        ]
      },
      usage: {
        title: 'Information Usage',
        content: 'We use collected information to provide you with the following services:',
        items: [
          {
            icon: '🛠️',
            text: 'Product installation, debugging and maintenance services'
          },
          {
            icon: '📞',
            text: 'Technical support and customer service response'
          },
          {
            icon: '📊',
            text: 'Product quality tracking and improvement optimization'
          },
          {
            icon: '🔧',
            text: 'Equipment fault diagnosis and remote support'
          },
          {
            icon: '📈',
            text: 'Product feature upgrades and new feature push'
          },
          {
            icon: '🤝',
            text: 'Business cooperation and customized services'
          }
        ]
      },
      protection: {
        title: 'Information Protection',
        content: 'We take multiple security measures to protect your personal information security:',
        measures: [
          {
            title: 'Data Encryption',
            description: 'Using SSL/TLS encryption technology to protect data transmission security, sensitive information is stored using AES-256 encryption.'
          },
          {
            title: 'Access Control',
            description: 'Implementing strict permission management systems, only authorized personnel can access relevant personal information.'
          },
          {
            title: 'Security Audit',
            description: 'Regular security audits and vulnerability scans to promptly identify and fix security vulnerabilities.'
          },
          {
            title: 'Data Backup',
            description: 'Establishing comprehensive data backup mechanisms to ensure data is not lost due to unexpected situations.'
          }
        ]
      },
      cookies: {
        title: 'Cookie Usage',
        content: 'Our website may use Cookie technology to improve user experience:',
        types: [
          {
            category: 'Essential Cookies',
            description: 'Ensure basic functions of the website operate normally, such as user authentication, shopping cart, etc.'
          },
          {
            category: 'Performance Cookies',
            description: 'Collect website usage statistics to help us improve website performance and user experience.'
          },
          {
            category: 'Functional Cookies',
            description: 'Remember user preference settings to provide personalized website experience.'
          },
          {
            category: 'Marketing Cookies',
            description: 'Used to display relevant advertising content and marketing information.'
          }
        ]
      },
      rights: {
        title: 'User Rights',
        content: 'According to relevant laws and regulations, you have the following rights:',
        items: [
          {
            title: 'Right to Know',
            description: 'You have the right to know how and why we collect and use your personal information.'
          },
          {
            title: 'Right to Access',
            description: 'You have the right to access personal information we hold about you.'
          },
          {
            title: 'Right to Rectification',
            description: 'When your personal information changes, you have the right to request us to update or correct it.'
          },
          {
            title: 'Right to Erasure',
            description: 'Under the premise of compliance with laws and regulations, you have the right to request us to delete your personal information.'
          },
          {
            title: 'Right to Data Portability',
            description: 'You have the right to obtain a copy of your personal information in a structured, common format.'
          }
        ]
      },
      sharing: {
        title: 'Third-party Sharing',
        content: 'Except as otherwise provided by laws and regulations, we will not share or transfer your personal information to third parties. We will only share your information in the following situations:',
        notice: {
          title: 'Important Notice',
          content: 'We require all third-party partners to strictly comply with this privacy policy and take sufficient security measures to protect your personal information security.'
        }
      },
      updates: {
        title: 'Policy Updates',
        content: 'We may update this privacy policy from time to time based on changes in laws and regulations, business development needs, or technological advancements. The updated policy will be published on our official website and will take effect from the date of publication. Please review this policy regularly to understand the latest information.'
      }
    }
  },
  
  // Cooperation Page
  cooperation: {
    title: 'Cooperation',
    subtitle: 'Creating a Better Future Together',
    description: 'We look forward to establishing long-term and stable cooperative relationships with outstanding partners from all walks of life to jointly promote the development and innovation of the biomedical industry.',
    process: {
      title: 'Cooperation Process',
      subtitle: 'Simple and efficient cooperation process to make cooperation smoother',
      steps: [
        {
          number: '01',
          title: 'Initial Contact',
          description: 'Contact us by phone, email or online form to express cooperation intentions and basic requirements'
        },
        {
          number: '02',
          title: 'Requirement Assessment',
          description: 'Our professional team will understand your needs in detail, conduct feasibility analysis and solution design'
        },
        {
          number: '03',
          title: 'Solution Discussion',
          description: 'Both parties conduct in-depth discussions on cooperation solutions, clarifying cooperation models, responsibility division and benefit distribution'
        },
        {
          number: '04',
          title: 'Agreement Signing',
          description: 'Sign formal cooperation agreement after reaching consensus, establishing rights and obligations relationship'
        },
        {
          number: '05',
          title: 'Project Implementation',
          description: 'Carry out cooperation projects according to agreement, communicate progress regularly to ensure smooth project advancement'
        },
        {
          number: '06',
          title: 'Ongoing Support',
          description: 'Provide continuous technical support and after-sales service after project completion, establishing long-term cooperative relationship'
        }
      ]
    },
    form: {
      title: 'Contact Us',
      subtitle: 'Please fill in the following information and we will contact you soon',
      name: 'Name',
      namePlaceholder: 'Please enter your name',
      company: 'Company Name',
      companyPlaceholder: 'Please enter your company name',
      phone: 'Phone Number',
      phonePlaceholder: 'Please enter your phone number',
      email: 'Email Address',
      emailPlaceholder: 'Please enter your email address',
      cooperationType: 'Cooperation Type',
      selectType: 'Please select cooperation type',
      message: 'Cooperation Requirements',
      messagePlaceholder: 'Please describe your cooperation requirements in detail...',
      submit: 'Submit Consultation',
      submitting: 'Submitting...',
      reset: 'Reset Form',
      successMessage: 'Submitted successfully! We will contact you soon.',
      types: {
        distribution: 'Product Distribution',
        technical: 'Technical Cooperation',
        research: 'R&D Cooperation',
        investment: 'Investment Cooperation',
        strategic: 'Strategic Cooperation',
        other: 'Other Cooperation'
      }
    }
  },
  
  // Error Page
  error: {
    title: 'Page Not Found',
    description: 'Sorry, the page you are looking for does not exist or has been removed. Please check the URL.',
    backHome: 'Back to Home'
  }
}